import { client, useQuery } from '@fhs/client';
import { ServiceMode, useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';
import { IBackendCartEntries } from '@rbi-ctg/menu';

import {
  brownie,
  chocolateChipCookie,
  laysClassic,
  mediumFountainDrink,
  nutritionCalorieMapping,
  oatmealCookie,
} from './constants';

export function useUpsellCartEntries() {
  const { store } = useStoreContext();
  const storeId = store.number ?? '';
  const { serviceMode } = useServiceModeContext();

  return useQuery({
    queryKey: ['upsells', storeId, serviceMode],
    enabled: Boolean(storeId && serviceMode),
    queryFn: async () => {
      const entriesToEnrich =
        serviceMode === ServiceMode.DELIVERY
          ? [chocolateChipCookie, oatmealCookie]
          : [mediumFountainDrink, laysClassic, chocolateChipCookie, brownie];

      const enrichedCartEntriesResponse = await client.queries.enrichCartEntries({
        cartEntries: JSON.stringify(entriesToEnrich),
        storeId,
        serviceMode,
      });

      const entries = enrichedCartEntriesResponse.data?.entries ?? [];

      return entries.flatMap(entry => {
        if (!entry) {
          return [];
        }

        return {
          ...entry,
          children: JSON.parse(entry.children?.toString() ?? '[]', reviveEnrichedCartEntry),
          pickerSelections: JSON.parse(
            entry.pickerSelections?.toString() ?? '{}',
            reviveEnrichedCartEntry
          ),
          nutrition: {
            calories:
              entry.sanityId in nutritionCalorieMapping
                ? nutritionCalorieMapping[entry.sanityId]
                : null,
          },
        };
      }) as Array<IBackendCartEntries & { nutrition: { calories: number | null } }>;
    },
  });
}

function reviveEnrichedCartEntry(key: string, value: unknown) {
  if ((key === 'children' || key === 'pickerSelections') && typeof value === 'string') {
    return JSON.parse(value, reviveEnrichedCartEntry);
  }

  return value;
}
